<template>
    <div>
        TEST
    </div>
</template>
<script>
export default {
    name: "test"
}
</script>